module.exports = __webpack_public_path__ + "logout.png?79f82b6fbe3870d4bf3025bf5db05335";